<template>
  <div class="call-container">
    <a-spin :spinning="loading">
      <div class="search-container" ref="searchContainerRef">
        <div class="search-item">
          <a-select
            @change="changeServiceFlag"
            v-model:value="queryParam.serviceFlag"
            placeholder="选择服务记录"
            style="width: 224px"
            size="large"
            allowClear
          >
            <a-select-option :value="0">被动服务记录</a-select-option>
            <a-select-option :value="1">主动服务记录</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.direction"
            placeholder="选择通话类型"
            style="width: 224px"
            size="large"
            allowClear
            :options="directionFlagMap"
          />
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.doctorAssistantName"
            placeholder="选择健管"
            style="width: 224px"
            size="large"
            allowClear
            mode="multiple"
          >
            <a-select-option v-for="c in UserList.as" :value="c" :key="c">
              {{ c }}
            </a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.assistantName"
            placeholder="选择BD"
            style="width: 224px"
            size="large"
            allowClear
            mode="multiple"
          >
            <a-select-option v-for="c in UserList.bd" :value="c" :key="c">
              {{ c }}
            </a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="queryParam.doctorName"
            size="large"
            :maxlength="50"
            placeholder="搜索医生姓名"
            allowClear
          />
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.actualIntent"
            placeholder="选择实际诉求"
            style="width: 224px"
            size="large"
            allowClear
          >
            <a-select-option :value="1">服务咨询</a-select-option>
            <a-select-option :value="2">投诉建议</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-input
            class="search-input"
            v-model:value="queryParam.patientName"
            size="large"
            :maxlength="20"
            placeholder="搜索患者姓名"
            allowClear
          />
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.endStatus"
            placeholder="选择通话状态"
            style="width: 224px"
            size="large"
            allowClear
          >
            <a-select-option :value="item.val" v-for="item in statusOptions" :key="item.val">
              {{ item.lable }}
            </a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            style="width: 300px"
            v-model:value="beginTimeList"
            :placeholder="['呼出开始日期', '呼出结束日期']"
            allowClear
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD"
            @change="handleParaDate"
          />
        </div>
        <div class="search-item">
          <a-select
            v-model:value="queryParam.processingFlag"
            placeholder="选择处理状态"
            style="width: 224px"
            size="large"
            allowClear
            :options="processingFlagMap"
          ></a-select>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="searchList">
            搜索
          </a-button>
        </div>
      </div>
      <div class="call_log">
        <div class="table">
          <a-table
            :dataSource="tableData"
            :columns="col"
            :pagination="false"
            :rowKey="(record, index) => index"
            :scroll="{ x: 1800, y: tableScrollY }"
            @change="handleTableChange"
          >
            <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
            <template #callerType="{ record }">
              <div
                :style="{ cursor: [-1, 1].includes(record.callerType) ? 'pointer' : 'default' }"
                @click="openPatientFile(record, [-1, 1].includes(record.callerType))"
                class="service_person"
              >
                <roles :solerType="record.callerType" />
                <PatientNameAgeReveal
                  v-if="[-1, 1].includes(record.callerType)"
                  :name="record.callerName"
                  :name-clickable="true"
                  @name-click="openPatientFile(record, [-1, 1].includes(record.callerType))"
                  @click.stop
                />
                <span v-else>{{ record.callerName }}</span>
                <auth-img :src="callIcon" />
              </div>
            </template>
            <!-- 接听人 calleeType 主叫方类型：1患者、2医生、3bd、4医生助手-->
            <template #calleeName="{ record }">
              <div
                :style="{ cursor: [-1, 1].includes(record.calleeType) ? 'pointer' : 'default' }"
                @click="openPatientFile(record, [-1, 1].includes(record.calleeType))"
                class="service_person"
              >
                <roles :solerType="record.calleeType" />
                <PatientNameAgeReveal
                  v-if="[-1, 1].includes(record.calleeType)"
                  :name="record.calleeName"
                  :name-clickable="true"
                  @name-click="openPatientFile(record, [-1, 1].includes(record.calleeType))"
                  @click.stop
                />
                <span v-else>{{ record.calleeName }}</span>
              </div>
            </template>
            <!-- 电话时长 -->
            <template #duration="{ record, index }">
              <template v-if="record.duration">
                <div @click="play(index)" class="call_duration" v-if="!record.isPlay">
                  <auth-img :src="playIcon" />
                  <span>{{ renderTime(record.duration) }}</span>
                </div>
                <div v-if="record.isPlay">
                  <audio :src="record.audioUrl" controls ref="audioRef"></audio>
                </div>
              </template>
              <template v-else>--</template>
            </template>
            <!-- 通话状态 -->
            <template #endStatusDesc="{ record }">
              <span :class="{ red: record.errorStatusFlag }">
                {{ record.endStatusDesc || '--' }}
              </span>
            </template>
            <!-- 关联工单-->
            <template #action="{ record }">
              <a v-if="showWorkOrderBtn(record)" @click="getWorkOrder(record)">查看</a>
              <span v-else>--</span>
            </template>
            <!-- 处理标识 -->
            <template #processingFlag="{ record }">
              <template v-if="record.buttonDisplay">
                <!-- 去除管理员权限 均可处理 -->
                <!-- <span v-if="isAdmin">{{ record.processingFlag === 1 ? '已处理' : '未处理' }}</span> -->
                <a-radio @change="changeStatus(record)" :checked="record.processingFlag === 1">
                  {{ record.processingFlag === 1 ? '已处理' : '未处理' }}
                </a-radio>
                <!-- {{ record.processingFlag === 1 ? '已处理' : '未处理' }} -->
              </template>
              <span v-else>--</span>
            </template>
            <!-- 拨打 -->
            <template #call="{ record }">
              <div v-if="record.buttonDisplay || record.readSummaryCheck">
                <!-- <a
                  v-if="record.chatSummaryId && record.processingFlag"
                  :style="{ marginRight: '10px' }"
                  @click="handleSummary(record, 2)"
                >
                  处理通话ID:{{ record.cdrId }}
                </a> -->
                <a :style="{ marginRight: '10px' }" @click="openFullText(record)">通话全文</a>
                <!-- 呼入 + 未接通 + 有健管参与的 才能有处理按钮 -->
                <a
                  v-if="record.buttonDisplay"
                  @click="call(record)"
                  :style="{ marginRight: '10px' }"
                >
                  拨打电话
                </a>
                <a v-if="record.manualProcessedSummaryCheck" @click="handleSummary(record)">
                  人工小结
                </a>
                <!-- 只有本人可以编辑 编辑提交后全员可看 -->
                <a
                  v-if="record.manualProcessedSummaryCheck === 0 && record.readSummaryCheck"
                  @click="handleSummary(record)"
                >
                  查看小结
                </a>
                <!-- ai生成失败 -->
                <template v-if="record.chatSummaryStatus === 0">
                  <a v-if="record.chatSummaryRetryCount < 2" @click="onCreateSummary(record)">
                    AI重新生成小结
                  </a>
                  <a v-else v-show="record.writeSummaryCheck" @click="handleSummary(record)">
                    填写小结
                  </a>
                </template>
                <!-- record.fillSummaryCheck -->
                <a v-if="record.fillSummaryCheck" @click="createSummary(record, 10)">填写小结</a>
              </div>
              <span v-else>--</span>
            </template>
            <template #serviceMatters="{ text }">
              {{ text || '--' }}
            </template>
          </a-table>
        </div>
        <div class="pagination">
          <a-pagination
            show-size-changer
            v-model:current="pagination.current"
            v-model:pageSize="pagination.pageSize"
            :total="pagination.total"
            @change="onShowSizeChange"
            @showSizeChange="onShowSizeChange"
            :show-total="total => `总共 ${pagination.total} 条`"
          />
        </div>
      </div>
    </a-spin>
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="closeSummaryModal"
        :origin="origin"
        :active="summaryActive"
      />
    </a-modal>
    <EditSummary ref="editSummaryRef" @changeTab="getData" @ok="SummaryOk" @close="SummaryClose" />
    <FullText ref="FullTextRef" />
  </div>
</template>
<script setup>
import { columns, directionFlagMap, paginationConfig, processingFlagMap } from './config'
import { reactive, ref, onMounted, onUnmounted, nextTick, computed, createVNode } from 'vue'
import playIcon from '@/assets/img/chat/playIcon.png'
import callIcon from '@/assets/img/chat/callIcon.png'
import { getCdrList, getTccEndStatus } from '@/api/chat'
import { useRouter } from 'vue-router'
import { getQueryUser, processed } from '@/api/login'
import { useStore } from 'vuex'
import { callOut } from '@/utils/Tccc'
import useRevisitPoolGuard from '@/hooks/useRevisitPoolGuard'
import { Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import summaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import { renderTime, showWorkOrderBtn } from '@/utils'
import moment from 'moment'
import { roleMap } from '@/components/Tccc/config'
import { useSummary } from '@/hooks/useSummary'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { cloneDeep } from 'lodash-es'
import FullText from '@/components/FullText/index.vue'
import PatientNameAgeReveal from '@/components/PatientNameAgeReveal.vue'
import { summary } from '../WorkPlace/Container/chat/components/ServiceAttributionModal/ServiceDetail/components/ServiceProgress/constant'
import { manualByCdrIds } from '@/api/workPlace/summary'

const store = useStore()
const statusOptions = ref([])
const col = ref(columns)
const router = useRouter()
const defaultParam = {
  serviceFlag: undefined,
  assistantName: [],
  doctorAssistantName: [],
  doctorName: null,
  patientName: null,
  endStatus: null,
  startQueryTime: '',
  endQueryTime: '',
  processingFlag: null,
  direction: null,
  actualIntent: null,
  processingTimeSort: null
}
const beginTimeList = ref([])
const queryParam = reactive({
  ...defaultParam
})
const tableData = ref([])
const audioRef = ref(null)
const loading = ref(false)
const origin = ref('')
const UserList = reactive({
  bd: [],
  as: []
})
const pagination = reactive({ ...paginationConfig })
const defaultCacheQuery = {
  ...defaultParam,
  beginTimeList: [],
  current: paginationConfig.current,
  pageSize: paginationConfig.pageSize
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.CALL_LOG_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    beginTimeList: Array.isArray(params?.beginTimeList) ? params.beginTimeList : [],
    assistantName: Array.isArray(params?.assistantName) ? params.assistantName : [],
    doctorAssistantName: Array.isArray(params?.doctorAssistantName)
      ? params.doctorAssistantName
      : []
  })
})

const searchContainerRef = ref(null)
const searchContainerHeight = ref(0)
const tableScrollY = computed(() => {
  const fixedHeight = 210
  return `calc(100vh - ${fixedHeight + searchContainerHeight.value}px)`
})

const updateSearchHeight = () => {
  nextTick(() => {
    searchContainerHeight.value = searchContainerRef.value?.offsetHeight || 0
  })
}

const applyCacheQuery = cacheQuery => {
  Object.assign(queryParam, defaultParam, cacheQuery)
  beginTimeList.value = cacheQuery.beginTimeList || []
  pagination.current = cacheQuery.current || paginationConfig.current
  pagination.pageSize = cacheQuery.pageSize || paginationConfig.pageSize
}

const persistCache = () => {
  updateCache({
    ...queryParam,
    beginTimeList: beginTimeList.value,
    current: pagination.current,
    pageSize: pagination.pageSize
  })
}
// 获取通话记录状态
const getStutusOptions = () => {
  getTccEndStatus().then(res => {
    statusOptions.value = res.map(it => {
      return { lable: it.value, val: it.code }
    })
    statusOptions.value.unshift({
      lable: '全部',
      val: ''
    })
  })
}
onMounted(() => {
  updateSearchHeight()
  window.addEventListener('resize', updateSearchHeight)
  applyCacheQuery(initFromCache())
  getData()
  getBDList()
  getHealthUserList()
  getStutusOptions()
})

onUnmounted(() => {
  window.removeEventListener('resize', updateSearchHeight)
})
const getBDList = (serviceFlag = 0) => {
  getQueryUser({ accountType: 3, serviceFlag }).then(res => {
    UserList.bd = res || []
  })
}
const getHealthUserList = (serviceFlag = 0) => {
  getQueryUser({ accountType: 4, serviceFlag }).then(res => {
    UserList.as = res || []
  })
}
// 改变每页条数
const onShowSizeChange = (page, pageSize) => {
  pagination.pageSize = pageSize
  pagination.current = page
  persistCache()
  getData()
}
// 获取数据
function getData() {
  loading.value = true
  const { pageSize, current } = pagination
  const query = {
    ...queryParam,
    pageSize,
    pageNo: current
  }
  getCdrList(query)
    .then(res => {
      const { list, currPage, totalCount } = res
      pagination.current = currPage
      pagination.total = totalCount
      tableData.value = list
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
const {
  editSummaryRef,
  summaryActive,
  chatSummaryId,
  summaryPanelVisible,
  handleSummary,
  onCreateSummary,
  closeSummaryModal,
  createSummary
} = useSummary(getData)
// 播放录音
function play(index) {
  console.log(index)
  tableData.value.forEach(it => (it.isPlay = false))
  tableData.value[index].isPlay = true
  nextTick(() => {
    audioRef.value.play()
  })
}

//查看关联工单
const getWorkOrder = record => {
  router.push({
    path: '/todo',
    query: {
      workOrderIdList: record.workOrderIds.join('、')
    }
  })
}

const resetQuery = () => {
  beginTimeList.value = []
  Object.assign(queryParam, defaultParam)
  Object.assign(pagination, paginationConfig)
  persistCache()
  getData()
  updateSearchHeight()
}
const searchList = () => {
  Object.assign(pagination, paginationConfig)
  persistCache()
  getData()
  updateSearchHeight()
}
// NOTE: 废弃但是保留，可能后期还要改回来
const changeStatus2 = record => {
  // 如果是已处理状态 获取已处理信息并弹窗展示
  const showWarningModal = message => {
    Modal.warning({
      centered: true,
      title: '提示',
      icon: createVNode(ExclamationCircleOutlined),
      content: message,
      okText: '我知道了',
      onOk: () => {
        store.dispatch('tccc/getCallunProcessedCount')
        getData()
        Modal.destroyAll()
      }
    })
  }
  Modal.confirm({
    centered: true,
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: '未接通话记录确认已处理？',
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await processed({ cdrId: record.cdrId })
        const { code, value } = res

        if (code === '40001') {
          showWarningModal(value)
        } else {
          store.dispatch('tccc/getCallunProcessedCount')
          getData()
          // if (record.chatSummaryId) {
          //   handleSummary(record)
          // } else {
          // createSummary(record, 10)
          // }
          createSummary(record, 10)
        }
      } catch (error) {
        console.error('处理失败:', error)
      }
    }
  })
}
const changeStatus = record => {
  createSummary(record, 10)
}
const call = record => {
  const doCall = crossPoolParams => {
    const params = {
      calleeType: record.callerType,
      calleeUcUserId: record.callerUcUserId,
      doctorId: record.doctorId,
      workOrderIds: record.workOrderIds || [],
      phone: record.tcccCaller,
      // 跨回访池确认拨打埋点参数，随拨打参数透传至 record-save-before-call
      ...crossPoolParams
    }
    callOut(params, {
      userType: roleMap[record.callerType],
      name: record.callerName
      // header: ''
    })
  }
  const confirmCall = () => {
    Modal.confirm({
      centered: true,
      title: '确定拨打电话',
      icon: createVNode(ExclamationCircleOutlined),
      content: `确定给${roleMap[record.callerType]}-${record.callerName}拨打电话吗？`,
      okText: '拨打',
      cancelText: '取消',
      onOk: () => doCall()
    })
  }
  // 仅被呼叫人为患者时校验回访任务池（-1/1均为患者），医生/BD等其他角色走原确认流程
  if ([-1, 1].includes(record.callerType)) {
    useRevisitPoolGuard({
      ucPatientId: record.callerUcUserId,
      source: 'callLog',
      onPass: confirmCall,
      onContinue: doCall
    })
  } else {
    confirmCall()
  }
}
const handleParaDate = val => {
  queryParam.startQueryTime = formatTime(val[0])
  queryParam.endQueryTime = formatTime(val[1])
}
const formatTime = date => {
  if (date === undefined || date === null || !date) {
    return ''
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}
function changeServiceFlag(e) {
  searchList()
  getBDList(e)
  getHealthUserList(e)
  updateSearchHeight()
  const serviceMatters = col.value.findIndex(f => f.title === '服务事项')
  if (e) {
    // 主动服务
    const param = {
      title: '服务事项',
      dataIndex: 'serviceMatters',
      key: 'serviceMatters',
      align: 'left',
      slots: {
        customRender: 'serviceMatters'
      }
    }
    serviceMatters === -1 && col.value.splice(col.value.length - 1, 0, param)
  } else {
    // 被动服务 服务事项列隐藏
    // const serviceMatters = col.value.findIndex(f => f.title === '服务事项')
    serviceMatters > -1 && col.value.splice(serviceMatters, 1)
  }
}
// 打开患者档案
function openPatientFile(record, isPatient = false) {
  if (isPatient) {
    const { patientAccountType, patientId, prePatientId } = record
    const params = {
      patientId: patientAccountType === 1 ? patientId : prePatientId,
      patientType: patientAccountType === 1 ? 1 : 0,
      doctorId: record.doctorId ? record.doctorId : null
    }
    // 患者
    store.dispatch('patientFile/openModal', params)
  } else {
    // Message.info('请先选择患者')
  }
}
const FullTextRef = ref(null)
const openFullText = record => {
  const { cdrId } = record
  FullTextRef.value.openModal(cdrId)
}
//
const handleTableChange = (_, __, sorter) => {
  // console.log(sorter)
  const { columnKey, order } = sorter
  if (columnKey === 'processingTime') {
    switch (order) {
      case 'ascend':
        queryParam.processingTimeSort = 1
        break
      case 'descend':
        queryParam.processingTimeSort = 2
        break
      default:
        queryParam.processingTimeSort = null
        break
    }
  }
  getData()
}
const SummaryOk = params => {
  console.log('SummaryOk', params)
  const pendingCdrIds = params.pendingCdrIds || []
  manualByCdrIds(pendingCdrIds)
    .then(result => {
      getData()
    })
    .catch(err => {})
}
const SummaryClose = () => {
  //   getData()
}
</script>
<style scoped lang="scss">
.call-container {
  position: relative;
  height: 100%;
}
.red {
  color: #f5222d;
}
.search-container {
  padding: 10px 20px 0;
  background-color: #ffffff;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search-input {
      width: 224px;
    }
  }
}
.call_log {
  padding: 20px;
  .table {
    .service_person {
      img {
        margin-left: 8px;
      }
      .soler {
        font-weight: 400;
        font-size: 12px;
        border-radius: 4px;
        padding: 2px 6px;
        margin-right: 4px;
        &.pa {
          background: #ffeed9;
          color: #ffa940;
        }
        &.do {
          background: #d6eaff;
          color: #1890ff;
        }
        &.bd {
          color: #1fb5ab;
          background: #e6f5f1;
        }
        &.assistant {
          color: #722ed1;
          background: #f9f0ff;
        }
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .call_duration {
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 12px;
      }
    }
  }
  .pagination {
    margin-top: 16px;
  }
}
</style>
